import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { DailyTaskDetailReportschemaObject } from "../DailyTaskDetailReportSchema";
import { validateProperty } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _, { forEach } from 'lodash';
import MaterialTable from "material-table";
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';

const screenCode = "DAILYTASKDETAILREPORT";

export function DailyTaskDetailReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [taskCategory, setTaskCategory] = useState();
    const [labourTask, setLabourTask] = useState()
    const [fields, setFields] = useState();
    const [jobs, setJobs] = useState();
    const [gtnnumber, setGtnnumber] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [dailyTaskDetailReport, setDailyTaskDetailReport] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        fieldID: "0",
        searchDate: "",
        category: "0",
        task: "0",
        jobTypeID: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        field: "0",
        searchDate: "",
        category: "0",
        task: "0",
        jobTypeID: "0"
    })
    const [csvData, setCsvData] = useState([]);

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);
    const [summarizedData, setSummarizedData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const schema = Joi.object(DailyTaskDetailReportschemaObject).options({ allowUnknown: true });
    const contentRowNames = ["collectionPointName", "firstName", "employeeTypeName", "registrationNumber", "fieldName",
        "jobTypeID", "taskName", "progress", "startTime", "endTime", "duration", 'otHours']

    const renderJobType = rowData => rowData.jobTypeID === '1' ? "General" : "Cash";

    const [reportData, setReportData] = useState([]);
    const [reportDataOne, setReportDataOne] = useState([]);
    const [keys, setKeys] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown(),

        );
    }, []);

    useEffect(() => {
    }, [summarizedData, totalCount]);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
            getTaskNames(),

        )
    }, [dailyTaskDetailReport.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
            getTaskNames(),
        )
    }, [dailyTaskDetailReport.estateID])

    useEffect(() => {
        trackPromise(
            getGtnNumberForDropDown()
        )
    }, [dailyTaskDetailReport.searchDate])

    useEffect(() => {
        trackPromise(
            getLabourTask()
        )
    }, [dailyTaskDetailReport.category])

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint(),
        )
    }, [dailyTaskDetailReport.divisionID]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getJobsForDropdown(),
        );
    }, []);

    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            fieldID: "0"
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0"
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            divisionID: target.value,
            fieldID: "0"
        });
    }

    function handleFieldChange(target) {
        validateInputs(target);
        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            fieldID: target.value
        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            searchDate: target.value

        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, DailyTaskDetailReportschemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYTASKDETAILREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setDailyTaskDetailReport({
                ...dailyTaskDetailReport,
                groupID: token.groupID
            });

        } else {
            setDailyTaskDetailReport({
                ...dailyTaskDetailReport,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }

        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(dailyTaskDetailReport.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(dailyTaskDetailReport.estateID);
        setDivisions(data);
    }

    async function getTaskNames() {
        const result = await services.getAllTaskNames(dailyTaskDetailReport.groupID, dailyTaskDetailReport.estateID);
        setTaskCategory(result);
    }

    async function getLabourTask() {
        const result = await services.getLabourTaskByOperationEntityIDTaskCategoryID(dailyTaskDetailReport.estateID, dailyTaskDetailReport.category);
        setLabourTask(result)
    }

    async function getFeildsByCollectionPoint() {
        const fields = await services.GetAvialableFieldsForDropdown(dailyTaskDetailReport.divisionID);
        setFields(fields);
    }

    async function getGtnNumberForDropDown() {
        const data = await services.getGtnNumberByCollectionPointIDandDate(dailyTaskDetailReport);
        setGtnnumber(data);
    }

    async function getJobsForDropdown() {
        const result = await services.getJobsForDropdown();
        setJobs(result);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.type === "checkbox" ? target.checked : target.value;
        setDailyTaskDetailReport({
            ...dailyTaskDetailReport,
            [e.target.name]: value,
        });
    }

    async function handleSearch(e) {

        e.preventDefault();

        const summarizedResult = {};
        let total = 0;

        setIsTableHide(true);

        setButtonHide(true);

        getSelectedDropdownValuesForReport(dailyTaskDetailReport);

        setIsTableHide(true);
        const result = await services.getDailyTaskDetailReportData(dailyTaskDetailReport);
        let groupedResult = groupByGtn(result);
        let keys = Object.keys(groupedResult);

        result.forEach(x => {
            if (x.enityTypeID == 1) {
                x.fieldName = "Factory";
            } else {
                x.fieldName = x.fieldName;
            }
        })

        result.forEach((item) => {
            const fieldName = item.fieldName;
            const firstName = item.firstName;

            if (!summarizedResult[fieldName]) {
                summarizedResult[fieldName] = {};
            }

            if (!summarizedResult[fieldName][firstName]) {
                summarizedResult[fieldName][firstName] = 1;
            } else {
                summarizedResult[fieldName][firstName]++;
            }

            total++;
        });

        const summarizedArray = Object.keys(summarizedResult).map((fieldName) => ({
            fieldName,
            count: Object.keys(summarizedResult[fieldName]).reduce(
                (acc, firstName) => acc + summarizedResult[fieldName][firstName],
                0
            ),
        }));

        setTotalCount(total);
        setSummarizedData(summarizedArray);

        setKeys(keys);
        setReportData(result);
        setReportDataOne(groupedResult);

        if (result.length > 0) {
            result.forEach(x => {
                x.startTime = moment(x.startTime).format('h:mm:ss a');
                x.endTime = moment(x.endTime).format('h:mm:ss a');
            })
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }

        setButtonHide(false);
        setIsReportButtonsEnabled();

        const comlpeteData = [...result];
        setCsvData(comlpeteData)
    }

    async function createFile() {
        var settings = {
            sheetName: 'Sundry Factory Check List',
            fileName: 'Sundry/FactoryCheckList',
            writeOptions: {}
        };

        const mainCsvHeaders = [
            { label: "Collection Point", value: "collectionPointName" },
            { label: "Emp Name", value: "firstName" },
            { label: "Emp Type", value: "employeeTypeName" },
            { label: "Reg No", value: "registrationNumber" },
            { label: "Field", value: "fieldName" },
            { label: "Job Type", value: "jobTypeID" },
            { label: "Task", value: "taskName" },
            { label: "Percentage%", value: "progress" },
            { label: "OT Hours", value: "otHours" },
        ];

        var copyOfCsv = _.cloneDeep(csvData);
        copyOfCsv.forEach(row => {
            row.jobTypeID = row.jobTypeID === 1 ? 'General' : row.jobTypeID === 2 ? 'Cash' : '-';
        });

        const summaryTable = {};
        let totalCount = 0;

        var newRow1 = {
            collectionPointName: "Total Summary",
            firstName: "Field Name",
            employeeTypeName: "Description",
            registrationNumber: "Labour Count"
        };
        newRow1.registrationNumber = totalCount === 0 ? "Labour Count" : "-";

        csvData.forEach(row => {
            const fieldName = row.fieldName;
            const firstName = row.firstName;

            if (fieldName && firstName) {
                if (!summaryTable[fieldName]) {
                    summaryTable[fieldName] = { firstName: fieldName, registrationNumber: 0 };
                }
                summaryTable[fieldName].registrationNumber++;
                totalCount++;
            }
        });

        const summaryTableArray = Object.values(summaryTable);
        const totalRow = { collectionPointName: "Total", registrationNumber: totalCount };

        var newRow2 = {
            collectionPointName: "Date",
            firstName: "Name",
            employeeTypeName: "Designation",
            registrationNumber: "Signature"
        };

        copyOfCsv.push({}, newRow1, ...summaryTableArray, totalRow, {}, {}, newRow2);

        copyOfCsv.push(
            { employeeTypeName: "Asst. Field Officer / Field Officer " },
            { employeeTypeName: "Field Officer " },
            { employeeTypeName: "Asst. Superintendent " },
            { employeeTypeName: "Asst. Clerk - Data Operator " }
        );

        var newRow3 = {
            collectionPointName: "Group :" + groups[dailyTaskDetailReport.groupID],
            firstName: "Operation Entity : " + estates[dailyTaskDetailReport.estateID],
            employeeTypeName: "Date : " + dailyTaskDetailReport.searchDate,
            registrationNumber: "Generated date/time : " + new Date().toLocaleString(),
            fieldName: "Generated user : " + tokenService.getUserNameFromToken()
        };

        const combinedTable = [...copyOfCsv, {}, newRow3];

        xlsx(
            mainCsvHeaders,
            combinedTable,
            settings,
            true
        );
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            field: fields[searchForm.fieldID],
            category: searchForm.category,
            task: searchForm.task,
            date: searchForm.searchDate,
            jobTypeID: searchForm.jobTypeID
        })
    }

    function groupByGtn(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['gtnNumber']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    function handleSearchDropdownChange(data) {

        if (data === undefined || data === null) {
            setDailyTaskDetailReport({
                ...dailyTaskDetailReport,
                task: "0"
            });
        }
        else {
            var nameV = "taskID";
            var valueV = data["taskID"];

            setDailyTaskDetailReport({
                ...dailyTaskDetailReport,
                task: valueV.toString()
            });
        }
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Sundry / Factory Check List"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={dailyTaskDetailReport.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID"> Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={dailyTaskDetailReport.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Division</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={dailyTaskDetailReport.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--All Divisions--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    {/* <div className="col-md pb-1">
                                        <InputLabel shrink id="category">Category</InputLabel>
                                        <Select
                                            fullWidth
                                            id="category"
                                            name="category"
                                            value={dailyTaskDetailReport.category}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Task Category--</MenuItem>
                                            {generateDropDownMenu(taskCategory)}
                                        </Select>
                                    </div> */}
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fieldID">Field</InputLabel>
                                        <Select fullWidth
                                            id="fieldID"
                                            name="fieldID"
                                            value={dailyTaskDetailReport.fieldID}
                                            onChange={(e) => handleFieldChange(e.target)}>
                                            <MenuItem value="0">--All Field--</MenuItem>
                                            {generateDropDownMenu(fields)}
                                        </Select>
                                        {errors["fieldID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="task">Task</InputLabel>
                                        <Autocomplete
                                            fullWidth
                                            id="task"
                                            options={labourTask}
                                            getOptionLabel={(option) => option.taskName}
                                            size="small"
                                            onChange={(event, value) => handleSearchDropdownChange(value)}
                                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                                        />
                                        {errors["task"] && <FormHelperText error>{errors["task"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="jobTypeID">Job Type</InputLabel>
                                        <Select
                                            fullWidth
                                            id="jobTypeID"
                                            name="jobTypeID"
                                            value={dailyTaskDetailReport.jobTypeID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--All Job type--</MenuItem>
                                            {generateDropDownMenu(jobs)}
                                        </Select>
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="table-responsive row-top-gap">
                                        <MaterialTable
                                            title="Multiple Actions Preview"
                                            columns={[
                                                { title: 'Collection Point', field: 'collectionPointName', headerStyle: { fontWeight: "bold" } },
                                                { title: 'Reg No', field: 'registrationNumber', headerStyle: { fontWeight: "bold" } },
                                                { title: 'Emp Name', field: 'firstName', headerStyle: { fontWeight: "bold" } },
                                                { title: 'Emp Type', field: 'employeeTypeName', headerStyle: { fontWeight: "bold" } },
                                                { title: 'Field', field: 'fieldName', headerStyle: { fontWeight: "bold" } },
                                                {
                                                    title: 'Job Type', field: 'jobTypeID',
                                                    render: rowData => rowData.jobTypeID == 1 ? "General" : rowData.jobTypeID == 2 ? "Cash" : "-", headerStyle: { fontWeight: "bold" }
                                                },
                                                { title: 'Task ', field: 'taskName', headerStyle: { fontWeight: "bold" } },
                                                { title: 'Percentage(%)', field: 'progress', headerStyle: { fontWeight: "bold" } },
                                                { title: 'OT Hours', field: 'otHours', headerStyle: { fontWeight: "bold" } }
                                            ]}
                                            data={reportData}
                                            options={{
                                                exportButton: false,
                                                showTitle: false,
                                                headerStyle: { textAlign: "left", height: '1%' },
                                                cellStyle: { textAlign: "left" },
                                                columnResizable: false,
                                                actionsColumnIndex: -1
                                            }}
                                        />
                                    </div>
                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactToPrint
                                            documentTitle={"Sundry Factory Checklist Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"
                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} dataOne={reportDataOne}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} keys={keys}
                                            summarizedData={summarizedData} totalCount={totalCount} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
